import styled from 'styled-components';

export const EditDatevWrapper = styled.div`
  & > div:first-child {
    margin-bottom: 16px;
  }

  .ant-form-item {
    width: 288px;
  }
`;

export const DeleteButton = styled.div<{ isDisabled: boolean }>`
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-left: 18px;

  ${({ isDisabled, theme }) =>
    isDisabled &&
    `
    & > div {
      color: ${theme.colors.grayVariations.murky};
    }
  `}
`;
